var api = require("!../../../../.nvm/versions/node/v14.21.3/lib/node_modules/@fangzhou/stark/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../.nvm/versions/node/v14.21.3/lib/node_modules/@fangzhou/stark/node_modules/css-loader/dist/cjs.js??clonedRuleSet-5.use[1]!../../../../.nvm/versions/node/v14.21.3/lib/node_modules/@fangzhou/stark/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-5.use[2]!../../../../.nvm/versions/node/v14.21.3/lib/node_modules/@fangzhou/stark/node_modules/less-loader/dist/cjs.js??clonedRuleSet-5.use[3]!./runtime.less?modules}");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};